import { useTheme } from 'styled-components';
import { useEffect } from 'react';

import { TransactionAppliedFilters } from 'src/types';
import { DesertedIcon } from 'src/assets';
import { useTransactionsModalGe, useTranslation } from 'src/hooks';

import { TransactionLoader } from 'src/content-loaders';
import { useTransactionsTableGe } from './hooks/useTransactionTableGe';
import { MobileTable } from './components/MobileTable';

import {
  EmptyStateWrapper,
  TableWrapper,
  TransactionTableContainer,
  WideTable,
  CustomEmpyState,
} from './styles';

type TransactionTableGeType = {
  skip?: number;
  take: number;
  modalLeftSpace?: number;
  appliedFilters?: TransactionAppliedFilters;
  setHasTransactions?: (n: boolean) => void;
  hasTransactions?: boolean;
  className?: string;
  isOneAssetTransactions?: boolean;
};

const TransactionTableGe: React.FC<TransactionTableGeType> = ({
  skip = 0,
  take = 9,
  appliedFilters,
  setHasTransactions,
  modalLeftSpace,
  hasTransactions = true,
  className,
  isOneAssetTransactions,
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const { transactionModal, openModal, handleTransactionDetails } =
    useTransactionsModalGe(0);

  const handleTransactionClick = (selectedId: number) => {
    handleTransactionDetails(selectedId);
    openModal();
  };

  const { columns, data, handleRowClick, dataIsLoaded, loading, transactions } =
    useTransactionsTableGe({
      skip,
      take,
      appliedFilters,
      onRowClick: handleTransactionClick,
      isOneAssetTransactions,
    });

  useEffect(() => {
    if (dataIsLoaded) {
      setHasTransactions?.(data.length !== 0);
    }
  }, [setHasTransactions, dataIsLoaded, data]);

  if (!dataIsLoaded || loading) {
    return <TransactionLoader />;
  }

  return (
    <TransactionTableContainer
      className={className}
      hasTransactions={hasTransactions}
    >
      {data.length ? (
        <>
          <TableWrapper>
            <WideTable
              columns={columns}
              data={data}
              onClick={handleRowClick}
              bodyHeight={6.8}
              headerHeight={4.1}
              headerColor={colors.surface.interactiveDefault}
              hasStickyHeader={false}
            />
          </TableWrapper>
          <MobileTable
            transactions={transactions}
            handleTransactionClick={handleTransactionClick}
          />
        </>
      ) : (
        <EmptyStateWrapper className="empty-state">
          <CustomEmpyState
            title={t('transaction_not_found_title')}
            description={t('dashboard_transaction_not_found_desc')}
            img={DesertedIcon}
          />
        </EmptyStateWrapper>
      )}
      {transactionModal}
    </TransactionTableContainer>
  );
};

export default TransactionTableGe;
